import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app.routing';
import { AngularMaterialModule } from './shared/angular-material.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { NgxMatDatetimePickerModule, NgxMatNativeDateModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { AppComponent } from './app.component';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { FooterComponent } from './shared/footer/footer.component';
import { FileUploadModule } from 'ng2-file-upload';
import { ComponentsModule } from './components/components.module';
import { WidgetModule } from './widget/widget.module';
import { UserListComponent } from './route/user/user-list/user-list.component';
import { InscriptionListComponent } from './route/inscription/inscription-list/inscription-list.component';
import { InscriptionAddComponent } from './route/inscription/inscription-add/inscription-add.component';
import { AgePipe } from './pipe/age.pipe';
import { DateformatPipe } from './pipe/dateformat.pipe';
import { DateRangePickerModule } from '@syncfusion/ej2-angular-calendars';
import { InscriptionEditComponent } from './route/inscription/inscription-edit/inscription-edit.component';
import { JwtInterceptor } from './service/auth/jwt.interceptor';
import { InscriptionScanComponent } from './route/inscription/inscription-scan/inscription-scan.component';
import { MyAutofocusDirective } from './my-autofocus.directive';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { AccueilComponent } from './route/accueil/accueil.component';

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    FooterComponent,
    UserListComponent,
    InscriptionListComponent,
    InscriptionAddComponent,
    AgePipe,
    DateformatPipe,
    InscriptionEditComponent,
    InscriptionScanComponent,
    MyAutofocusDirective,
    AccueilComponent,
  ],
  imports: [
    BrowserModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ComponentsModule,
    WidgetModule,
    AppRoutingModule,
    AngularMaterialModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-top-center',
      preventDuplicates: false,
    }),
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule,
    NgxSpinnerModule,
    NgMultiSelectDropDownModule,
    DateRangePickerModule,
    NgxChartsModule,
    FileUploadModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
